export default __webpack_public_path__ + "static/media/single-choice-icon.4267fd28.svg";